import { Component, AfterContentInit, ChangeDetectionStrategy, AfterContentChecked, ChangeDetectorRef} from '@angular/core';

import { SectionFormDirective } from '@app/classes/section-form.class';
import { reset } from '@app/helpers/reset.helpers';
import { isExported, isRmbRmc } from '@app/helpers/mode.helpers';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { formatTableData } from '@app/helpers/tables.helpers';
import { Title } from '@angular/platform-browser';
import { ApplicationService } from '@app/services/application/application.service';
import { GlobalTranslateService } from '@app/services/globalTranslate/globalTranslate.service';
import { ServiceConfigService } from '@app/services/service-config.service';
import { from } from 'rxjs';


@Component({
    templateUrl: './dependent-care.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DependentCareComponent extends SectionFormDirective implements AfterContentInit, AfterContentChecked {
  isReadOnlyDependent: any = null;
  isRmbRmc = false;
  indi = [];
  someoneEn = {
    name: {
      fullName: 'Someone outside of the home'
    },
    identifier: "1"
  };
  someoneSp = {
    name: {
      fullName: 'Alguien fuera de casa'
    },
    identifier: "1"
  };
  someone;
  individualQues;
  individualQuesEn = "Who pays for this care? <div class=hint>If more than one person in your home has this dependent care expense, you can add another after you complete this page and click <b>Next</b>.</div>";
  individualQuesSp = "¿Quién paga este cuidado? <div class=hint>Si más de una persona del hogar tiene este gasto de cuidado de dependientes, puede agregarlo después de completar esta página y hacer clic en <b>Siguiente</b>.</div>";
  individualQuesAriaEn = "Who pays for this care? If more than one person in your home has this dependent care expense, you can add another after you complete this page and click Next.";
  individualQuesAriaSp = "¿Quién paga este cuidado? Si más de una persona del hogar tiene este gasto de cuidado de dependientes, puede agregarlo después de completar esta página y hacer clic en Siguiente.";
  translatedLang;
  defaultLanguage;
  otherHealthCareList;
  answeredBrstCervCancerSw;
  answeredEcfSw;
  answeredHcbsSw;
  answeredHospiceSw;
  answeredIntelDisbSw;
  answeredMedFacilitySw;
  answeredeMedicalBillsIndSw;
  answeredMedicareIndSw;
  answeredNursingHomeSw;
  answeredSsiBenefitsSw;
  finalListOfIndividuals = [];
  spousalRelationMedicare;
  finalParentIndvsForLessThanEighteenMedicare;
  noMedicalBills;
  answeredKtBeckettSw;
  ktBeckettIndividuals;
  spousalRelationForOtherSwitches;
  relationshipList;
  otherHealthCareListData;
  finalListIndvs;
  brstCervCancerSwChecked;
  ecfSwChecked;
  hcbsSwChecked;
  hospiceSwChecked;
  intelDisbSwChecked;
  medFacilitySwChecked;
  medicalBillsIndSwChecked;
  medicareIndSwChecked;
  nursingHomeSwChecked;
  ssiBenefitsSwChecked;
  otherIndvsCheckedMedicare;
  spousalRelation;
  otherSwitchesSpouse = [];
  otherSwitchesCheckedIndvs;
  otherSwitchesCheckedIndviduals =  [];
  ageOfIndividualsLessThanEighteen;
  finalParentIndvsForLessThanEighteenOther;
  finalParentIndvsForLessThanEighteenOtherSwitches = [];
  user = sessionStorage.getItem('userType');
  appType = sessionStorage.getItem('appType');
  isAFBorFC = (this.appType === 'AFB') || (this.user == 'RP' && (this.appType === 'AFB'));
  checkForDropdown: boolean = false;
  isEbmsDriverFlow = JSON.parse(sessionStorage.getItem("embsDriverFlow"))
  awsTranslateSwitch: boolean = false;

  
  constructor(private titleService: Title, builder: FormBuilder, public translateService: TranslateService, private application: ApplicationService, private cd: ChangeDetectorRef, private globalTranslateService: GlobalTranslateService, private serverConfig: ServiceConfigService) {
    super(builder);
    this.titleService.setTitle('Dependent Care');
  }

  ngAfterContentInit() {
    this.checkForDropdown = (this.isAFBorFC && this.members.length > 1);
    this.awsTranslateSwitch = this.serverConfig.getServerConfig().awsTranslateSwitch;
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.languageCheck(this.defaultLanguage);
    this.isRmbRmc = isRmbRmc(this.mode);
    
    // Initialize values based on default language
    this.updateTranslatedValues(this.defaultLanguage);

    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.languageCheck(res.lang);
      this.updateTranslatedValues(res.lang);
    });
    const dependantIndivNumberExist = !!this.getValue('data.dependantCareInformation.dependantIndivNumber');
    const dependantIndivNumberVal = this.getValue('data.dependantCareInformation.dependantIndivNumber');
    if (this.record && isExported(this.record.exportingStatus) && dependantIndivNumberExist) {
      this.isReadOnlyDependent = true;
    }
    const personOutsideHome = this.getControl('data.dependantCareInformation.personOutOfHouseholdName');
    personOutsideHome.disable();

    const individual = this.getControl('extras.individual');
    const dependantIndivNumber = this.getControl('data.dependantCareInformation.dependantIndivNumber');

    if ((!dependantIndivNumberVal ||dependantIndivNumberVal === "1") && this.getValue('data.dependantCareInformation.personOutOfHouseholdName')) {
      const dependantIndivNumber = this.getControl('data.dependantCareInformation.dependantIndivNumber');
      this.indi = [...this.otherIndividuals, ...[this.someone]];
      if (this.indi.length > 0) {
        dependantIndivNumber.patchValue("1")
        personOutsideHome.enable();
      }
    }
    this.registerToggle(individual, () => reset(dependantIndivNumber));

    if((individual?.value?.identifier === dependantIndivNumber?.value || dependantIndivNumber?.value === '0') && this.isEbmsDriverFlow) {
      dependantIndivNumber?.setValue(null);
    } 

    //code for filtering the dropdowns for checked individuals on gatepost questions
    //only if AFB or FC and no. of people on the application is > 1
    if(this.isAFBorFC && this.members.length > 1){
      this.application.getSection(this.applicationNumber, 'AIBAO').subscribe(rtn => {
        if (rtn.records.length > 0) {
          const { records } = rtn;
          this.otherHealthCareListData = records[0].data;
          if (this.members.length > 1) {
            this.getGatePostQuestionsDetails(this.otherHealthCareListData);

            this.application.getSection(this.applicationNumber, 'HHRLS').subscribe(rtn => {
              if (rtn.records.length > 0) {
                const { records } = rtn;
                this.relationshipList = records[0].data.relationshipList;
                if (this.members.length > 1) {
                  this.getRelnAndCheckedIndvsMedicareAndOtherSwitches(this.relationshipList);
                  this.finalList();
                };
              }
            });

          };
        }
      });
    }

  }

  ngAfterViewInit(): void {
    window.scroll(0,0);
    setTimeout(() => {
      const heading = document.querySelector('h1.page-title-h1') as HTMLElement;
      if (heading) { heading.style.outline = 'none'; heading.focus(); }
    }, 100);
  }

  updateTranslatedValues(lang: string) {
    let selectedLang = sessionStorage.getItem('globalTranslatedLan') && 
                        sessionStorage.getItem('globalTranslatedLan') !== 'undefined' ? sessionStorage.getItem('globalTranslatedLan') : null;
    
    if(selectedLang === 'es'){
      selectedLang = 'sp';
    }
    
    // Set text based on language for en and sp
    if (lang === 'en') {
      this.individualQues = this.individualQuesEn;
    } else {
      this.individualQues = this.individualQuesSp;
    }
    
    // Set "someone" option - use AWS translate for non-en/sp languages
    if(!this.awsTranslateSwitch || !selectedLang || selectedLang === 'en' || selectedLang === 'sp' || selectedLang === 'es'){
      if (lang === 'en') {
        this.someone = this.someoneEn;
      } else {
        this.someone = this.someoneSp;
      }
    }
    // For other languages, translate "someone" option only
    else {
      from(this.globalTranslateService.translate(this.someoneEn.name.fullName, selectedLang))
        .subscribe((translatedSomeone) => {
          this.someone = {
            name: {
              fullName: translatedSomeone
            },
            identifier: "1"
          };
          this.cd.detectChanges();
        });
    }
  }

  languageCheck(language) {
    this.tables = language === 'sp' ? formatTableData(this.tables, 'spDescription') : formatTableData(this.tables, 'description');
  }

  tableCodeValue (tableName, tableControl){
    return this.getTableCodeValues(tableName, tableControl, this.translatedLang)
  }

  setIndiv() {
    const personOutsideHome = this.getControl('data.dependantCareInformation.personOutOfHouseholdName');
    if (this.getValue('data.dependantCareInformation.dependantIndivNumber') === "1")
      personOutsideHome.enable();
    else personOutsideHome.disable();
  }

  ngAfterContentChecked () {
    if (this.otherIndividuals) {
      this.indi = [...this.otherIndividuals, ...[this.someone]];
    }
  }

 getRelnAndCheckedIndvsMedicareAndOtherSwitches(relationshipList ) {

    const otherSwitchesArray = [this.medFacilitySwChecked, this.medicalBillsIndSwChecked, this.nursingHomeSwChecked];
    const spoParStparNamesArray = ["medfac", "medbills", "nurhome"];
    
    for(let i = 0; i < otherSwitchesArray.length; i++){
      this.spouseAndCheckedIndvsForOtherSwitches(relationshipList,otherSwitchesArray[i], spoParStparNamesArray[i]);
    };

    this.otherSwitchesSpouse = this.otherSwitchesSpouse.reduce((acc, val) => acc.concat(val), []);
    this.otherSwitchesCheckedIndviduals = this.otherSwitchesCheckedIndviduals.reduce((acc, val) => acc.concat(val), []);
    this.finalParentIndvsForLessThanEighteenOtherSwitches = this.finalParentIndvsForLessThanEighteenOtherSwitches.reduce((acc, val) => acc.concat(val), []);
  };



  spouseAndCheckedIndvsForOtherSwitches(relationshipList, switchName, codedName){
  // spouse and other checked indviduals for medFacilitySwChecked, medicalBillsIndSwChecked, nursingHomeSwChecked

    if(switchName.length > 0){
      if(codedName === "medbills" || codedName === "medfac" || codedName === "nurhome"){
        this.spousalRelation = switchName.map((e)=>{
          let tempM = relationshipList.filter(element=> ((element.sourceIndividual === e) || (element.referenceIndividual === e)) &&
                                                        ((element.relation.code === 'SPO') ))
          return tempM;
        });

        this.spousalRelation = (this.spousalRelation.map(item => 
          ({"source" : item[0]?.sourceIndividual, "reference":item[0]?.referenceIndividual})).map(data => Object.values(data)));

        this.spousalRelation = (this.spousalRelation.reduce((acc, val) => acc.concat(val), [])).filter(data => data !== undefined);
        console.log(this.spousalRelation);
      }


      if(codedName === "nurhome" ||  codedName === "medbills" ){
        this.ageOfIndividualsLessThanEighteen = this.individuals.filter(item => item.age < 18).map(data => JSON.parse(data.identifier));

        let ageOfIndividualsLessThanEighteenChecked = switchName.map((e)=>{
          let tempC = this.ageOfIndividualsLessThanEighteen.filter(element=> (element === e))
          return tempC;
        });

        ageOfIndividualsLessThanEighteenChecked = (ageOfIndividualsLessThanEighteenChecked.reduce((acc, val) => acc.concat(val), [])).filter(data => data !== undefined);
        console.log(ageOfIndividualsLessThanEighteenChecked);

        let parentalRelationForLessThanEighteen = ageOfIndividualsLessThanEighteenChecked.map((e)=>{
            let temp = relationshipList.filter(element=> ((element.sourceIndividual === e) || (element.referenceIndividual === e)) &&
                                                          ((element.relation.code === 'FAO') || (element.relation.code === 'MOO') ||
                                                            (element.relation.code === 'SFA') || (element.relation.code === 'SMO') ||
                                                            (element.relation.code === 'SDA') || (element.relation.code === 'SSO') ||
                                                            (element.relation.code === 'DAU') || (element.relation.code === 'SON') ))
            return temp;
        });

        parentalRelationForLessThanEighteen = parentalRelationForLessThanEighteen.reduce((acc, val) => acc.concat(val), []);

        let listParentIndvsForLessThanEighteen = (parentalRelationForLessThanEighteen.map(item => ({"source" : item.sourceIndividual, "reference":item.referenceIndividual})).map(data => Object.values(data)));
        listParentIndvsForLessThanEighteen = listParentIndvsForLessThanEighteen.reduce((acc, val) => acc.concat(val), []);

        if(codedName === "kt"){
          listParentIndvsForLessThanEighteen = listParentIndvsForLessThanEighteen.filter( x => !ageOfIndividualsLessThanEighteenChecked.includes(x) );
        }

        this.finalParentIndvsForLessThanEighteenOther = listParentIndvsForLessThanEighteen.filter((c, index) => {
          return listParentIndvsForLessThanEighteen.indexOf(c) === index;
        });
      }
      
      this.otherSwitchesCheckedIndvs = switchName;
    };


    if(switchName.length > 0){
      if(this.spousalRelation.length > 0){
        this.otherSwitchesSpouse.push(this.spousalRelation);
      }
      if(this.finalParentIndvsForLessThanEighteenOther && this.finalParentIndvsForLessThanEighteenOther.length > 0){
        this.finalParentIndvsForLessThanEighteenOtherSwitches.push(this.finalParentIndvsForLessThanEighteenOther);
      };
      if(this.otherSwitchesCheckedIndvs.length > 0){
        this.otherSwitchesCheckedIndviduals.push(this.otherSwitchesCheckedIndvs);
      }
    };

  };


  getGatePostQuestionsDetails(otherHealthCareListData) {
    const otherHealthCareList = otherHealthCareListData?.otherBenefitsIndvProfileData;
    this.otherHealthCareList = otherHealthCareList;
    this.answeredYesToGatePostQuestions(otherHealthCareListData);
  }


  answeredYesToGatePostQuestions(otherBenefitsDataRecord){
    //list of individuals who checked for each switch in gatepost questions
    const otherBenefitsData = otherBenefitsDataRecord?.otherBenefitsIndvProfileData;
    this.brstCervCancerSwChecked = otherBenefitsData.filter(data => data.brstCervCancerSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.ecfSwChecked = otherBenefitsData.filter(data => data.ecfSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.hcbsSwChecked = otherBenefitsData.filter(data => data.hcbsSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.hospiceSwChecked = otherBenefitsData.filter(data => data.hospiceSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.intelDisbSwChecked = otherBenefitsData.filter(data => data.intelDisbSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.medFacilitySwChecked = otherBenefitsData.filter(data => data.medFacilitySw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.medicalBillsIndSwChecked = otherBenefitsData.filter(data => data.medicalBillsIndSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.medicareIndSwChecked = otherBenefitsData.filter(data => data.medicareIndSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.nursingHomeSwChecked = otherBenefitsData.filter(data => data.nursingHomeSw?.code === 'Y').map(element => JSON.parse(element?.indvId));
    this.ssiBenefitsSwChecked = otherBenefitsData.filter(data => data.ssiBenefitsSw?.code === 'Y').map(element => JSON.parse(element?.indvId));


    //what gatepost questions are answered as yes
    this.answeredKtBeckettSw = otherBenefitsDataRecord?.kbReferralSw?.code === 'Y';
    let brstCervCancerSw = otherBenefitsData.map(item => item?.brstCervCancerSw?.code === 'Y');
    let ecfSw = otherBenefitsData.map(item => item?.ecfSw?.code === 'Y');
    let hcbsSw = otherBenefitsData.map(item => item?.hcbsSw?.code === 'Y');
    let hospiceSw = otherBenefitsData.map(item => item?.hospiceSw?.code === 'Y');
    let intelDisbSw = otherBenefitsData.map(item => item?.intelDisbSw?.code === 'Y');
    let medFacilitySw = otherBenefitsData.map(item => item?.medFacilitySw?.code === 'Y');
    let medicalBillsIndSw = otherBenefitsData.map(item => item?.medicalBillsIndSw?.code === 'Y');
    let medicareIndSw = otherBenefitsData.map(item => item?.medicareIndSw?.code === 'Y');
    let nursingHomeSw = otherBenefitsData.map(item => item?.nursingHomeSw?.code === 'Y');
    let ssiBenefitsSw = otherBenefitsData.map(item => item?.ssiBenefitsSw?.code === 'Y');

 
    this.answeredBrstCervCancerSw = brstCervCancerSw.some(data => data === true);
    this.answeredEcfSw = ecfSw.some(data => data === true);
    this.answeredHcbsSw = hcbsSw.some(data => data === true);
    this.answeredHospiceSw = hospiceSw.some(data => data === true);
    this.answeredIntelDisbSw = intelDisbSw.some(data => data === true);
    this.answeredMedFacilitySw = medFacilitySw.some(data => data === true);
    this.answeredeMedicalBillsIndSw = medicalBillsIndSw.some(data => data === true);
    this.answeredMedicareIndSw = medicareIndSw.some(data => data === true);
    this.answeredNursingHomeSw = nursingHomeSw.some(data => data === true);
    this.answeredSsiBenefitsSw = ssiBenefitsSw.some(data => data === true);
  }


  finalList(){
    //Final List of Individuals to be displayed in the dropdown
    if(this.answeredMedFacilitySw || this.answeredeMedicalBillsIndSw || this.answeredNursingHomeSw){
      this.finalListOfIndividuals = this.finalListOfIndividuals.concat(this.otherSwitchesSpouse).concat(this.otherSwitchesCheckedIndviduals).concat(this.finalParentIndvsForLessThanEighteenOtherSwitches);
    }

    const finalListIndvsData = this.finalListOfIndividuals.filter((c, index) => {
      return this.finalListOfIndividuals.indexOf(c) === index;
    });

    
    this.finalListIndvs = finalListIndvsData.map((e)=>{
      let temp = this.individuals.filter(element=> ((JSON.parse(element.identifier) === e)))
      return temp;
    });

    this.finalListIndvs = this.finalListIndvs.reduce((acc, val) => acc.concat(val), []);
    this.cd.detectChanges();

    console.log(this.finalListIndvs);

  }
}